import React from 'react'

const wrapperStyle = {
  display: 'flex',
  justifyContent: 'center',
  padding: '48px 24px',
}

const cardStyle = {
  width: '100%',
  maxWidth: '720px',
  padding: '40px 36px',
  borderRadius: '18px',
  backgroundColor: '#ffffff',
  boxShadow: '0 24px 60px rgba(50, 50, 93, 0.12)',
}

const badgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '64px',
  height: '64px',
  marginBottom: '24px',
  borderRadius: '999px',
  backgroundColor: '#fb6340',
  color: '#ffffff',
  fontSize: '30px',
  fontWeight: 700,
}

const titleStyle = {
  marginBottom: '12px',
  color: '#172b4d',
  fontSize: '32px',
  fontWeight: 700,
}

const paragraphStyle = {
  marginBottom: '16px',
  color: '#525f7f',
  fontSize: '16px',
  lineHeight: 1.7,
}

const NotAuthorized = () => {
  return (
    <div style={wrapperStyle}>
      <div style={cardStyle}>
        <div aria-hidden="true" style={badgeStyle}>
          !
        </div>
        <h1 style={titleStyle}>Accesso non autorizzato</h1>
        <p style={paragraphStyle}>
          Il tuo account ha effettuato correttamente il login, ma al momento non ha accesso ad
          alcun servizio su questa piattaforma.
        </p>
        <p style={paragraphStyle}>
          Contatta il tuo Team Manager per farti sbloccare il servizio di cui hai bisogno.
        </p>
      </div>
    </div>
  )
}

export default NotAuthorized
